import React from "react";
import { Reveal } from "./Reveal";
import { ASSETS } from "@/data";

const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="h-px w-8 bg-sf-ember" />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-sf-ember">{children}</span>
  </div>
);

export const Mission = () => {
  return (
    <section id="mission" data-testid="mission-section" className="relative py-24 md:py-36">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal>
            <div>
              <SectionLabel>The Mission</SectionLabel>
              <h2 className="sf-stencil text-4xl md:text-5xl text-sf-bone leading-[1.05]">
                Born at the Monroe Institute.
                <span className="block text-sf-dim">Forged on the Gateway Voyage.</span>
              </h2>
              <div className="mt-8 space-y-5 text-sf-dim text-base md:text-lg leading-relaxed">
                <p>
                  This deck was born on a Gateway Voyage at the Monroe Institute, shoulder to shoulder
                  with veterans and first responders — people who’d carried real weight in real
                  darkness. We went looking for something that understood us. We couldn’t find it.
                </p>
                <p>
                  So I built it. Not another love-and-light deck. Inner intel. Written in the voice of
                  someone who’s seen the silence after the sirens and chose to keep standing.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <figure className="relative">
              <div className="absolute -inset-4 bg-sf-ember/10 blur-3xl rounded-full" />
              <img
                src={ASSETS.boxMockup}
                alt="Sacred Frontline oracle deck box with cards on concrete"
                loading="lazy"
                className="relative rounded-md border border-sf-border w-full object-cover"
              />
            </figure>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <blockquote
            data-testid="mission-quote"
            className="mt-20 md:mt-28 border-l-2 border-sf-ember pl-6 md:pl-10 max-w-4xl"
          >
            <p className="sf-stencil text-2xl md:text-4xl lg:text-5xl leading-tight text-sf-bone">
              “Because we needed something that looked like us. That understood the silence after the
              sirens.”
            </p>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
};

export default Mission;
